export interface Geofence {
  geofenceId?: number;
  geofenceName: string;
  propertyId: number;
  propertyName?: string;
  tagIds?: number[];
  polygonCoordinates: GeofencePoint[];
  status?: 'ACTIVE' | 'INACTIVE';
  colourHex: string;
  address: { completeAddress: string };
  disabled?: boolean; // added in component level
}

export interface GeofenceFilter {
  search?: string;
  propertyIds?: number[];
  tagIds?: number[];
}

export interface GeofenceActivityFilter {
  search?: string;
  searchBy?: SearchBy;
  geofenceIds?: number[];
  propertyIds?: number[];
  tagIds?: number[];
  geofenceActivities?: string[];
}

export interface GeofencePoint {
  latitude: number;
  longitude: number;
}

export class ListGeofenceQueryParams {
  public skip: number;
  public limit: number;
  public geofenceId?: number;
  public search?: string;
  public propertyIds?: number[];
  public tagIds?: number[];

  constructor(params: { skip: number; limit: number; geofenceId?: number; search?: string; propertyIds?: number[]; tagIds?: number[] }) {
    this.skip = params.skip;
    this.limit = params.limit;

    if (params.geofenceId !== undefined && params.geofenceId !== null) {
      this.geofenceId = params.geofenceId;
    } else {
      delete this.geofenceId;
    }

    if (params.search) {
      this.search = params.search;
    } else {
      delete this.search;
    }

    if (params?.propertyIds?.length) {
      this.propertyIds = params.propertyIds;
    } else {
      delete this.propertyIds;
    }

    if (params?.tagIds?.length) {
      this.tagIds = params.tagIds;
    } else {
      delete this.tagIds;
    }
  }
}

export class CreateUpdateGeofenceParams {
  public geofenceName: string;
  public propertyId: number;
  public propertyName?: string;
  public tagIds?: number[];
  public polygonCoordinates: GeofencePoint[];
  public status?: 'ACTIVE' | 'INACTIVE';
  public colourHex: string;

  constructor(params: {
    geofenceName: string;
    propertyId: number;
    propertyName?: string;
    tagIds?: number[];
    polygonCoordinates: GeofencePoint[];
    status?: 'ACTIVE' | 'INACTIVE';
    colourHex?: string;
  }) {
    this.geofenceName = params.geofenceName;
    this.propertyId = params.propertyId;
    this.polygonCoordinates = params.polygonCoordinates;
    this.tagIds = params.tagIds;
    delete this.propertyName;
    delete this.status;
    delete this.colourHex;
  }
}

export interface GeofenceSetting {
  colourHex: string;
  propertyId: number;
  description: string;
  geofenceIds: number[];
  propertyName: string;
  geofenceRules: GeofenceRule[];
  geofenceAlerts: GeofenceAlerts;
}

export interface GeofenceRule {
  action: 'ENABLE' | 'DISABLE';
  target: 'DVR' | 'ADAS' | 'DMS' | 'PRIVACY';
  appliesTo: ('DRIVER' | 'ROAD')[];
}

export interface GeofenceAlerts {
  geofenceExit: boolean;
  geofenceEntry: boolean;
}

export type MapOverlayState = 'HOME' | 'GEOFENCE_CREATE_1' | 'GEOFENCE_CREATE_2' | 'CREATE' | 'UPDATE';

export type DataBusEvent =
  | 'SHOW_HOME'
  | 'SHOW_CREATE_GEOFENCE'
  | 'SHOW_UPDATE_GEOFENCE'
  | 'GEOFENCE_COORDINATES'
  | 'DRAW_GEOFENCE'
  | 'ENABLE_GEOFENCE'
  | 'DISABLE_GEOFENCE'
  | 'DELETE_GEOFENCE'
  | 'SET_GEOFENCE_COLOR'
  | 'SHOW_LOCATION_DETAILS'
  | 'SHOW_CREATE_GEOFENCE_SEARCH';

export interface GeofenceToast {
  id: number;
  type?: 'success' | 'error';
  message: string;
  duration?: number; // ms
}

export class ListGeofenceActivityQueryParams {
  public skip: number;
  public limit: number;
  public geofenceIds?: number[];
  public search?: string;
  public searchBy?: SearchBy;
  public propertyIds?: number[];
  public tagIds?: number[];
  public geofenceActivities?: string[];

  constructor(params: {
    skip: number;
    limit: number;
    geofenceIds?: number[];
    search?: string;
    searchBy?: SearchBy;
    propertyIds?: number[];
    tagIds?: number[];
    geofenceActivities?: string[];
  }) {
    this.skip = params.skip;
    this.limit = params.limit;

    if (params?.geofenceIds?.length) {
      this.geofenceIds = params.geofenceIds;
    } else {
      delete this.geofenceIds;
    }

    if (params.search) {
      this.search = params.search;
    } else {
      delete this.search;
    }

    if (params.searchBy && params.search) {
      this.searchBy = params.searchBy;
    } else {
      delete this.searchBy;
    }

    if (params?.propertyIds?.length) {
      this.propertyIds = params.propertyIds;
    } else {
      delete this.propertyIds;
    }

    if (params?.tagIds?.length) {
      this.tagIds = params.tagIds;
    } else {
      delete this.tagIds;
    }

    if (params?.geofenceActivities?.length) {
      this.geofenceActivities = params.geofenceActivities;
    } else {
      delete this.geofenceActivities;
    }
  }
}

export enum SearchBy {
  ASSET = 'ASSET',
  DRIVER = 'DRIVER',
}

export interface GeofenceActivityUserInfo {
  id: number;
  name: string;
  email: string;
  userId: string;
}

export type GeofenceActivityType = 'GeofenceUpdate' | 'GeofenceDisable' | 'GeofenceEnable' | 'GeofenceCreate' | 'GeofenceDelete';

export interface GeofenceActivity {
  tagIds: number[];
  userInfo: GeofenceActivityUserInfo;
  geofenceId: number;
  propertyId: number;
  geofenceName: string;
  timestampUTC: string;
  geofenceActivity: GeofenceActivityType;
}

export interface ListResponse<T> {
  rows: T[];
  skip: number;
  limit: number;
  totalCount: number;
}

export type GeofenceActivityListResponse = ListResponse<GeofenceActivity>;
